import React from 'react';
import Dialog from "@material-ui/core/Dialog";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';


function DufflePopUp(props) {
    const { open, from, data, flowFrom } = props

    const handleClose = () => {
        props.handleClose()
    }
    const { t } = useTranslation();


    return (
        <Dialog
            fullWidth
            maxWidth="sm"
            open={open}
            keepMounted
            onClose={handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
            className="fareType-dialog"
        >
            <div class="modal-header">
                <h5 class="modal-title" >PUB WEB.NDC Conditions</h5>
            </div>
            <div className='modal-body webFares_popup'>
                <ul className='ml-3'>
                    <li>
                        {t("Duffel 1")}
                    </li>
                    <li>
                        {t("Duffel 2")}
                    </li>
                    <li>
                        {t("Duffel 3")}
                    </li>
                    <li class='text-danger'>
                        {t("Duffel 4")}
                    </li>
                    <li class='text-danger'>
                        {t("Duffel 5")}
                    </li>
                    
                    <li>
                        {t("Duffel 6")}
                    </li>
                    <li>
                        {t("Duffel 7")}
                    </li><li>
                        {t("Duffel 8")}
                    </li>
                    <li className='font-weight-bold'>
                        {t("Duffel 9")}
                    </li>    
                        {/* <ul> */}
                    <li className="circle-style">
                        {t("Duffel 10")}
                    </li>
                    <li className="circle-style">
                        {t("Duffel 11")}
                    </li>
                    <li className="circle-style">
                        {t("Duffel 12")}
                    </li>
                    <li className="circle-style">
                        {t("Duffel 13")}
                    </li>
                    <li className="circle-style">
                        {t("Duffel 14")}
                    </li>
                    <li className="circle-style">
                        {t("Duffel 15")}
                    </li>
                    <li className="circle-style">
                        {t("Duffel 16")}
                    </li>
                    
                        {/* </ul> */}
                    {/* </li> */}
                </ul>
                <br/>
                <div class='font-weight-bold text-danger'>
                    {t("Duffel 17")}
                </div>
                <div class='font-weight-bold text-danger'>
                    {t("Duffel 18")}
                </div>
            </div>
        </Dialog>
    );
}

export default DufflePopUp;

